import { router, usePathname } from 'expo-router';
import { ChevronLeft } from 'lucide-react-native';
import { Pressable, StyleSheet, View } from 'react-native';

import { colors } from '@/src/theme/colors';

import {
  getHeaderBackFallbackPath,
  shouldShowHeaderBackButton,
  shouldUseHeaderBackFallback,
} from './header-back-button-visibility';

export function HeaderBackButton({
  fallbackPath,
  forceFallback = false,
}: {
  fallbackPath?: string;
  forceFallback?: boolean;
}) {
  const pathname = usePathname();
  const shouldShow = shouldShowHeaderBackButton(pathname);
  const resolvedFallbackPath =
    fallbackPath ?? getHeaderBackFallbackPath(pathname);

  if (!shouldShow) {
    return <View style={styles.placeholder} />;
  }

  return (
    <Pressable
      accessibilityLabel="Go back"
      accessibilityRole="button"
      onPress={() => {
        if (forceFallback || shouldUseHeaderBackFallback(pathname)) {
          router.replace(resolvedFallbackPath);
          return;
        }

        if (router.canGoBack()) {
          router.back();
          return;
        }

        router.replace(resolvedFallbackPath);
      }}
      style={({ pressed }) => [
        styles.button,
        pressed ? styles.buttonPressed : null,
      ]}
    >
      <ChevronLeft color={colors.text} size={28} strokeWidth={2.6} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    alignItems: 'center',
    height: 44,
    justifyContent: 'center',
    marginLeft: 4,
    width: 44,
  },
  buttonPressed: {
    opacity: 0.72,
  },
  placeholder: {
    height: 44,
    width: 44,
  },
});
